import { render } from "./UserPartners.vue?vue&type=template&id=43d241c0&scoped=true"
import script from "./UserPartners.vue?vue&type=script&lang=js"
export * from "./UserPartners.vue?vue&type=script&lang=js"

import "./UserPartners.vue?vue&type=style&index=0&id=43d241c0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d241c0"]])

export default __exports__